module.exports = {
      id: "icon-share-usage",
      viewBox: "0 0 25.6 25.6",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#icon-share",
      toString: function () {
        return this.url;
      }
    }